import { render, staticRenderFns } from "./riskAssessmentPop.vue?vue&type=template&id=88f57aca"
import script from "./riskAssessmentPop.vue?vue&type=script&lang=js"
export * from "./riskAssessmentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88f57aca')) {
      api.createRecord('88f57aca', component.options)
    } else {
      api.reload('88f57aca', component.options)
    }
    module.hot.accept("./riskAssessmentPop.vue?vue&type=template&id=88f57aca", function () {
      api.rerender('88f57aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskAssessmentPop.vue"
export default component.exports